module.exports = __webpack_public_path__ + "static/karrie-7026aa64d60c3b69a52f14753a30c55d.png";